import React from 'react';
import _ from 'lodash';

import { useSalesOrderSelectFieldQuery } from 'generated/graphql';



export interface ISalesOrder {
  id: string;
  name: string;
}

export interface IData {
  objects: ISalesOrder[];
}

export function useQuery(storeId: string) {
  const tuple = useSalesOrderSelectFieldQuery({
    variables: {
      storeId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(tuple.data?.orders.nodes ?? [], (node): ISalesOrder => ({
        id: node.id,
        name: node.orderNumber
      }))
    };

    return {
      loading: tuple.loading,
      data,
      refetch: async () => {
        tuple.refetch({});
      }
    };
  }, [tuple]);

  return wrappedTuple;
}
